import { centsToUsdString } from '@paperstac/helpers/lib/numberHelpers';
import PropTypes from 'prop-types';
import React from 'react';
import Cell from './Cell';
const CurrencyCell = /*#__PURE__*/React.memo(_ref => {
  let {
    cents,
    showCents,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Cell, props, cents ? centsToUsdString(cents, showCents) : '');
});
CurrencyCell.propTypes = {
  cents: PropTypes.number,
  showCents: PropTypes.bool
};
CurrencyCell.defaultProps = {
  showCents: true
};
CurrencyCell.displayName = 'CurrencyCell';
export default CurrencyCell;